import React from 'react';

const IconLocation = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.04125 3.53484C5.14125 3.53484 3.60125 5.07484 3.60125 6.97484C3.60125 8.87484 5.14125 10.4148 7.04125 10.4148C8.94125 10.4148 10.4812 8.87484 10.4812 6.97484C10.4812 5.07484 8.94125 3.53484 7.04125 3.53484ZM8.72125 6.97484C8.72125 7.89484 7.97125 8.65484 7.04125 8.65484C6.11125 8.65484 5.36125 7.90484 5.36125 6.97484C5.36125 6.04484 6.11125 5.29484 7.04125 5.29484C7.97125 5.29484 8.72125 6.04484 8.72125 6.97484Z"
        fill="currentColor"
      />
      <path
        d="M7.04125 0.214844C3.31125 0.214844 0.28125 3.24484 0.28125 6.97484C0.28125 9.40484 2.91125 13.1548 5.12125 15.8648C5.59125 16.4448 6.29125 16.7848 7.04125 16.7848C7.79125 16.7848 8.49125 16.4548 8.96125 15.8648C11.1713 13.1548 13.8013 9.40484 13.8013 6.97484C13.8013 3.24484 10.7712 0.214844 7.04125 0.214844ZM12.0413 6.97484C12.0413 8.42484 10.3813 11.3248 7.60125 14.7548C7.33125 15.0848 6.77125 15.0848 6.49125 14.7548C3.71125 11.3348 2.05125 8.42484 2.05125 6.97484C2.05125 4.22484 4.29125 1.98484 7.04125 1.98484C9.79125 1.98484 12.0413 4.22484 12.0413 6.98484V6.97484Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconLocation;
